import {FlashMessageInterface} from './flash-message.interface';

export class FlashMessage implements FlashMessageInterface {
    static nextId = 0;

    id: number = (FlashMessage.nextId++);
    text: string = 'default text';
    type: string = 'success';
    icon: string = '';
    cssClass: string = '';
    closeOnClick: boolean = false;
    showCloseBtn: boolean = false;
    timer: number;

    constructor(text?: string, type?: string, cssClass?: string, closeOnClick?: boolean,
                showCloseBtn?: boolean) {
        if (text) this.text = text;
        if (type) this.type = type;
        if (cssClass) this.cssClass = cssClass;
        if (closeOnClick) this.closeOnClick = closeOnClick;
        if (showCloseBtn) this.showCloseBtn = showCloseBtn;
    }
}
